module.exports = __webpack_public_path__ + "static/media/52.6fb27849.png";